import styled from 'styled-components';

import MUIContainer from '@material-ui/core/Container';

export { ProfileCodeAuth } from './Content';

export const Container = styled(MUIContainer).attrs({
  maxWidth: false,
  disableGutters: true,
})`
  height: calc(100vh - 4rem);
`;
